import Swal from 'sweetalert2';

export function loadingModal(mensaje) {
    Swal.fire({
        title: 'Espere',
        html: mensaje,
        allowOutsideClick: false,
        onBeforeOpen: () => {
            Swal.showLoading()
        }
    })
}

export function questionModal(titulo, mensaje) {
    return Swal.fire({
        title: titulo,
        text: mensaje,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar'
    })
}

export function errorModal(titulo, mensaje) {
    Swal.fire({
        icon: 'error',
        title: titulo,
        text: mensaje
    })
}

export function infoModal(titulo, mensaje) {
    Swal.fire({
        icon: 'info',
        title: titulo,
        html: mensaje
    });
}

export function warningModal (titulo, mensaje) {
    Swal.fire({
        icon: 'warning',
        title: titulo,
        html: mensaje
    });
}

export function deleteQuestionModal(mensaje) {
    return Swal.fire({
        title: mensaje,
        text: "Esta acción borrará de forma permanente el registro",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar'
    })
}

export function successModal(titulo, texto) {
    return Swal.fire(
        titulo,
        texto,
        'success'
    )
}
